import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {DateRangeFilter, PropertyFilter} from '../schedule/types';
import {VisibleDays} from '../report/types';

interface State {
    filter: {
        dateRangeFilter: DateRangeFilter;
        propertyFilter: PropertyFilter;
    };
    detailedByDay: boolean;
    visibleDays: VisibleDays;
}

const initialState: State = {
    filter: {
        dateRangeFilter: {
            startDate: '',
            endDate: ''
        },
        propertyFilter: {
            selectedEmployees: [],
            selectedProjects: [],
            selectedShiftTypes: [],
            selectedAbsenceTypes: [],
            selectedStatuses: [],
            showAbsences: true
        }
    },
    detailedByDay: false,
    visibleDays: VisibleDays.All
};

const timeTrackingFiltersSlice = createSlice({
    name: 'timeTrackingFilters',
    initialState,
    reducers: {
        updateDateRangeFilter: (state, action: PayloadAction<DateRangeFilter>) => {
            state.filter.dateRangeFilter = action.payload;
        },
        updatePropertyFilter: (state, action: PayloadAction<PropertyFilter>) => {
            state.filter.propertyFilter = action.payload;
        },
        updateDetailedByDay: (state, action: PayloadAction<boolean>) => {
            state.detailedByDay = action.payload;
        },
        updateVisibleDays: (state, action: PayloadAction<VisibleDays>) => {
            state.visibleDays = action.payload;
        }
    }
});

export const {
    updateDateRangeFilter,
    updatePropertyFilter,
    updateDetailedByDay,
    updateVisibleDays
} = timeTrackingFiltersSlice.actions;

export default timeTrackingFiltersSlice.reducer;
